export var SYMBOL = '<=';
export default function func(exp1, exp2) {
  return exp1 <= exp2;
}
func.SYMBOL = SYMBOL;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_hot-formula-parser@4.0.0@hot-formula-parser/evaluate-by-operator/operator/less-than-or-equal.mjs
// module id = null
// module chunks = 